/**
 * Nested router for the /match/* section. Wired into App.tsx as a
 * single splat route; all sub-routes live under this tree per design D10.
 */
import { Navigate, Route, Routes } from 'react-router-dom';
import { MatchHomePage } from './MatchHomePage';
import { MatchEntryPage } from './MatchEntryPage';
import { MatchAccountsPage } from './MatchAccountsPage';
import { MatchAccountDetailPage } from './MatchAccountDetailPage';
import { MatchAccountLedgerPage } from './MatchAccountLedgerPage';
import { MatchEntryDetailPage } from './MatchEntryDetailPage';

export default function MatchRouter() {
  return (
    <Routes>
      <Route index element={<MatchHomePage />} />
      <Route path="entry" element={<MatchEntryPage />} />
      <Route path="accounts" element={<MatchAccountsPage />} />
      <Route path="accounts/:id" element={<MatchAccountDetailPage />} />
      <Route
        path="accounts/:id/ledger"
        element={<MatchAccountLedgerPage />}
      />
      <Route path="entries/:id" element={<MatchEntryDetailPage />} />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  );
}
